import { render } from "./todoPage.vue?vue&type=template&id=2fe3a704"
import script from "./todoPage.vue?vue&type=script&lang=js"
export * from "./todoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__